import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import AnimatedSection from "./AnimatedSection";
import Icon from "./Icon";

function TrustSafety() {
  return (
    <section className="py-24 px-8 bg-surface-container-lowest overflow-hidden scroll-mt-20" id="trust">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        {/* Left - Text */}
        <div className="space-y-8">
          <AnimatedSection>
            <h2 className="font-headline text-4xl md:text-5xl font-extrabold tracking-tight">
              Every favour is a contract.
            </h2>
          </AnimatedSection>

          <AnimatedSection delay={0.1}>
            <p className="text-lg text-on-surface-variant leading-relaxed">
              We've eliminated the awkwardness of informal favors. Our platform provides a layer of legal and financial security for even the smallest tasks.
            </p>
          </AnimatedSection>

          <div className="space-y-6">
            <AnimatedSection delay={0.2}>
              <div className="flex items-start gap-4">
                <div className="mt-1 w-6 h-6 rounded-full bg-primary flex items-center justify-center">
                  <Icon name="check" className="text-white text-[16px]" filled />
                </div>
                <div>
                  <h4 className="font-bold text-on-surface">Verified Identities</h4>
                  <p className="text-on-surface-variant text-sm">
                    Every user undergoes a multi-layer verification process.
                  </p>
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection delay={0.3}>
              <div className="flex items-start gap-4">
                <div className="mt-1 w-6 h-6 rounded-full bg-primary flex items-center justify-center">
                  <Icon name="check" className="text-white text-[16px]" filled />
                </div>
                <div>
                  <h4 className="font-bold text-on-surface">Smart Escrow</h4>
                  <p className="text-on-surface-variant text-sm">
                    Funds are held securely and released only upon your digital signature.
                  </p>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>

        {/* Right - Trust Card */}
        <motion.div
          className="relative"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7 }}
        >
          <div className="glass-card p-12 rounded-[2.5rem] shadow-2xl border border-white/40 text-center relative z-10">
            <div className="inline-block p-4 bg-primary/5 rounded-full mb-6">
              <Icon name="workspace_premium" className="text-5xl text-primary" filled />
            </div>
            <div className="font-headline text-4xl md:text-5xl font-black text-on-surface mb-2 tracking-tight">
              Verified &amp; Protected
            </div>
            <p className="text-primary font-bold tracking-widest uppercase text-sm mb-8">
              Every favour, secured
            </p>

            {/* Avatar stack */}
            <div className="flex justify-center -space-x-4 mb-8">
              <div className="w-12 h-12 rounded-full border-4 border-white overflow-hidden bg-slate-200">
                <div className="w-full h-full bg-[#1bc9d1] flex items-center justify-center text-white text-xs font-bold">O</div>
              </div>
              <div className="w-12 h-12 rounded-full border-4 border-white overflow-hidden bg-slate-200">
                <div className="w-full h-full bg-secondary flex items-center justify-center text-white text-xs font-bold">F</div>
              </div>
              <div className="w-12 h-12 rounded-full border-4 border-white overflow-hidden bg-slate-200">
                <div className="w-full h-full bg-tertiary flex items-center justify-center text-white text-xs font-bold">D</div>
              </div>
              <div className="w-12 h-12 rounded-full border-4 border-white flex items-center justify-center bg-primary-container text-white">
                <Icon name="group" className="text-lg" filled />
              </div>
            </div>

            <Link
              to="/terms"
              className="block w-full py-4 rounded-xl bg-on-background text-white font-bold hover:bg-slate-800 transition-colors"
            >
              View Safety Protocols
            </Link>
          </div>

          {/* Abstract decorations */}
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-primary-container rounded-full blur-[80px] opacity-20"></div>
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-secondary rounded-full blur-[80px] opacity-20"></div>
        </motion.div>
      </div>
    </section>
  );
}

export default TrustSafety;
